import {Heading} from "@/components/ui/heading";
import React from "react";


const AffilateProgramElements = () => {
    return (
        <div className="affiliate-program-elements-container">
            <div className="affiliate-program--element">
                <Heading level={3}>
                    <span>1</span> Sign up to join the affiliate program.
                </Heading>
                <p>
                    Complete the form and provide the necessary information.
                </p>
            </div>
            <div className="affiliate-program--element">
                <Heading level={3}>
                    <span>2</span> Share your unique affiliate link.
                </Heading>
                <p>
                    Track the results and effects of your shares in your Locked Trade panel.
                </p>
            </div>
            <div className="affiliate-program--element">
                <Heading level={3}>
                    <span>3</span> Get 30% off every purchase.
                </Heading>
                <p>
                    You will receive a 30% commission on every purchase made through your affiliate link, up to 3 months if payment is recurring.
                </p>
            </div>
        </div>
    )
}

export default AffilateProgramElements;